import * as _ from 'lodash';
import ReactToggle from 'react-toggle';
import type { ChangeEvent } from 'react';
import type { ToggleProps } from 'react-toggle';

import { withTargetChecked } from '../../utils';

type FOSSAToggleProps = Omit<ToggleProps, 'disabled' | 'onChange'> & {
  //  Overrride default disabled, because we use `isDisabled` throughout the codebase.
  isDisabled?: boolean;
  //  Convenience for passing through if the toggle is checked or not.
  onChange: (isChecked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
};

/**
 * Wrapper around `react-toggle`.
 * By only using this toggle throughout the app, we can easily
 * replace this with our own generic version if we want in the future.
 */
const Toggle = (props: FOSSAToggleProps) => {
  const passThroughProps = _.omit(props, ['isDisabled', 'onChange']);

  return (<ReactToggle
    icons={false} // Default to no icons, but can be overridden
    {...passThroughProps} // eslint-disable-line react/jsx-props-no-spreading
    disabled={props.isDisabled}
    onChange={withTargetChecked(props.onChange)}
  />);
};

export default Toggle;
